module.exports = __webpack_public_path__ + "static/media/UdemyMongoDB.2307ef8e.jpg";